import type { MaybeRefOrGetter } from 'vue'
import { toValue, watchEffect } from 'vue'

const APP_TITLE = import.meta.env.VITE_PWA_APP_NAME || 'EverGPT'

export const setDocumentTitle = (context?: string | null) => {
  const page = context?.trim()
  document.title =
    page && page !== APP_TITLE && page !== 'EverGPT'
      ? `${APP_TITLE} - ${page}`
      : APP_TITLE
}

export const usePageTitle = (
  title: MaybeRefOrGetter<string | null | undefined>,
) => {
  watchEffect(() => {
    setDocumentTitle(toValue(title))
  })
}
